/**
 * Created by vaibhav on 1/4/18
 */
import React from 'react'
import PropTypes from 'prop-types'
import './styles.sass';

const Relatedlogos = () => {
    return (
        <section className="related-logos">
            <div className="columns">
            <div className = "column is-4">
            <img className ="grey-logo" src = '/img/seia.png'/>
            </div>
            <div className = "column is-4">
            <img className ="grey-logo" src = '/img/seia.png'/>
            </div>
            <div className = "column is-4">
            <img className ="grey-logo" src = '/img/seia.png'/>
            </div>
            </div>
        </section>
    );
};

export default Relatedlogos;



// WEBPACK FOOTER //
// ./src/components/Relatedlogos/index.js